import "./footer.css";

import Instagram from "../../../assets/Images/Elements/IG.svg";
import LinkedIn from "../../../assets/Images/Elements/LI.svg";
import YouTube from "../../../assets/Images/Elements/YT.svg";
import X from "../../../assets/Images/Elements/X.svg";

export default function Footer() {
    return (
        <footer className="Footer-Section-Main">

            {/* Top Border */}
            <div className="Footer-Section-Top-Border"></div>

            {/* Footer Links */}
            <div className="Footer-Section-Internals">

                {/* Coming Soon */}
                <div className="Footer-Section-Column">
                    <p className="FooterLabels">Coming Soon</p>
                </div>

                {/* Services */}
                <div className="Footer-Section-Column">
                    <p className="FooterLabels">Services</p>

                    <a className="MicroLinkText" href="/services/content-creation">
                        Content Creation
                    </a>
                    <a className="MicroLinkText" href="/services/paid-advertising">
                        Paid Advertising
                    </a>
                    <a className="MicroLinkText" href="/services/analytics-and-performance-reporting">
                        Performance Reporting
                    </a>
                    <a className="MicroLinkText" href="/services/digital-marketing-strategy">
                        Digital Marketing Strategy
                    </a>
                    <a className="MicroLinkText" href="/services/search-engine-optimization">
                        Search Engine Optimization
                    </a>
                    <a className="MicroLinkText" href="/services/website-design-and-development">
                        Website Development
                    </a>
                </div>

                {/* Blogs */}
                <div className="Footer-Section-Column">
                    <p className="FooterLabels">Blogs</p>

                    <a className="MicroLinkText" href="/blogs">
                        All blogs
                    </a>
                </div>

                {/* Get Help and Company */}
                <div className="Footer-Section-Column Footer-Section-Help-Company">

                    <div className="Footer-Section-Sub-Column">
                        <p className="FooterLabels">Get Help</p>

                        <a className="MicroLinkText" href="/contact">
                            Contact Us
                        </a>
                        <a className="MicroLinkText">
                            Mon-Sat: 10AM - 8PM
                        </a>
                        <a className="MicroLinkText">
                            contact@adstrate.in
                        </a>
                        <a className="MicroLinkText">
                            +91 8976 050 818
                        </a>
                        <a className="MicroLinkText">
                            +91 7666 814 040
                        </a>
                    </div>

                    <div className="Footer-Section-Sub-Column">
                        <p className="FooterLabels company">Company</p>

                        <a className="MicroLinkText" href="/about">
                            About
                        </a>
                        <a className="MicroLinkText" href="/privacy-policies">
                            Privacy policies
                        </a>
                        <a className="MicroLinkText" href="/terms-conditions">
                            Terms &amp; conditions
                        </a>
                    </div>

                </div>

            </div>

            {/* Footer Bottom */}
            <div className="Footer-Section-Bottom">

                <div className="Footer-Section-Bottom-Left">
                    <p className="Footer-Section-Copyright">
                        © 2026 Adstrate. All rights reserved
                    </p>

                    <div className="Footer-Section-Contact-Socials">
                        <a href="https://www.instagram.com/adstrate_in/" aria-label="Instagram">
                            <img src={Instagram} alt="Instagram" />
                        </a>

                        <a href="https://www.linkedin.com/in/adstrate-agency/" aria-label="LinkedIn">
                            <img src={LinkedIn} alt="LinkedIn" />
                        </a>

                        <a href="https://www.youtube.com/@adstrate" aria-label="YouTube">
                            <img src={YouTube} alt="YouTube" />
                        </a>

                        <a href="https://x.com/Adstrate_in" aria-label="X">
                            <img src={X} alt="X" />
                        </a>
                    </div>
                </div>

                <div className="Footer-Section-Wordmark">
                    <h2>Adstrate</h2>
                </div>

            </div>

        </footer>
    );
}